import { Search } from "lucide-react";

export function NoEvents() {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-card">
        <Search className="h-8 w-8 text-muted-foreground" />
      </div>
      <h2 className="mb-2 text-xl font-semibold text-foreground">
        No events found
      </h2>
      <p className="max-w-md text-muted-foreground">
        We couldn't find any events matching your search criteria.
      </p>
    </div>
  );
}
